import { render, staticRenderFns } from "./ReservationAccommodationSchedulerNotificationForm.vue?vue&type=template&id=3dfbb5a4&scoped=true&"
import script from "./ReservationAccommodationSchedulerNotificationForm.vue?vue&type=script&lang=js&"
export * from "./ReservationAccommodationSchedulerNotificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfbb5a4",
  null
  
)

export default component.exports